import store from "../state/store"

// export const resourceList = {
//     'patients_addPatients': '/dashboard/patients/addPatients',
//     "home": "/dashboard",
//     "patients": "/dashboard/patients",
//     "consultants": "/dashboard/consultants",
//     "roles": "/dashboard/roles",
//     "users": "/dashboard/users",
//     "organizations": "/dashboard/organizations",
//     "clinics": "/dashboard/clinics",
//     "appointments": "/dashboard/appointments",
//     "notifications": "/dashboard/notifications",
//     "todo": "/dashboard/todo",
//     "notes":"/dashboard/notes",
//     "uploadPatients":"/dashboard/uploadpatients",
//     "documents":"/dashboard/docs",
//     "wellnessvides": "/dashboard/wellnessvideos",
//     "orgDropDown": "/dashboard/orgDropDown",
//     "clinicDropDown": "/dashboard/clinicDropDown",
//     // "reportsGlobal": "show_monthly_revenue_report_global",
//     // "reportsOrg": "show_monthly_revenue_report_org",
//     // "reportsClinic": "show_monthly_revenue_report_clinic",
//     'bhnReports': "/dashboard/reports/bhn'stimespent",
//     'revenueReports': '/dashboard/reports/revenue',
//     "callLogs": "/dashboard/call_logs",
//     // "perfReportGlobal": "show_monthly_performance_report_global",
//     // "perfReportOrg": "show_monthly_performance_report_org",
//     // "perfReportClinic": "show_monthly_performance_report_clinic",
//     'performanceReports': '/dashboard/reports/careperformance',
//     // "carePlanReportGlobal":"show_monthly_care_plan_report_global",
//     // "carePlanReportClinic":"show_monthly_care_plan_report_clinic",
//     // "carePlanReportOrg":"show_monthly_care_plan_report_org",
//     'carePlanReport': '/dashboard/reports/careplan',
//     // "moodAmtReportGlobal":"show_monthly_mood_assessment_report_global",
//     // "moodAmtReportClinic":"show_monthly_mood_assessment_report_clinic",
//     // "moodAmtReportOrg":"show_monthly_mood_assessment_report_org",
//     "moodAssessmentReport": "/dashboard/reports/assessments",
//     // "aptReportGlobal":"show_monthly_appointments_report_global",
//     // "aptReportClinic":"show_monthly_appointments_report_clinic",
//     // "aptReportOrg":"show_monthly_appointments_report_org",
//     "appointmentsReports": '/dashboard/reports/appointments',
//     // "consentReportGlobal":"show_monthly_consents_report_global",
//     // "consentReportClinic":"show_monthly_consents_report_clinic",
//     // "consentReportOrg":"show_monthly_consents_report_org",
//     "consentReports": '/dashboard/reports/consent',
//     "invoices": "/dashboard/invoices",
//     "billing": "/dashboard/billing",
//     "billingForOrg":"Billing_org",
//     "billingForClinic":"Billing_clinic",
//     "invoiceForClinic":"Invoices_clinic",
//     "invoiceForOrg":"Invoices_org",
//     "showChatGPTSummary": "show_gpt",
//     "patientConsent":"/dashboard/patientsconsent",
//     "documentFilter": "Document Access",
//     'performanceGraph': '/dashboard/graphs/performance',
//     'engagementGraph': '/dashboard/graphs/engagement',
//     'consentGraph': '/dashboard/graphs/consent',
//     'patientsSmsConsent': '/dashboard/patients/smsConsent',
//     'documentsStatus': '/dashbaord/documents/status'
// };

export const resourceList = {
    dashboard: "/dashboard",
    dashboard_callsDashboard: "/dashboard/callsDashboard",
    dashboard_tasks: "/dashboard/tasks",
    dashboard_tasks_task_edit: "/dashboard/tasks/task/edit",
    dashboard_tasks_task_delete: "/dashboard/tasks/task/delete",
    dashboard_tasks_addTask: "/dashboard/tasks/addTask",
    dashboard_graphs: "/dashboard/graphs",
    dashboard_graphs_performanceReport: "/dashboard/graphs/performanceReport",
    dashboard_graphs_consentOverview: "/dashboard/graphs/consentOverview",
    dashboard_graphs_engagement: "/dashboard/graphs/engagement",
    dashboard_references: "/dashboard/references",
    patients: "/dashboard/patients",
    patients_addPatients: "/dashboard/patients/addPatients",
    patients_uploadPatients: "/dashboard/patients/uploadPatients",
    patients_active: "/dashboard/patients/active",
    patients_inActive: "/dashboard/patients/inActive",
    patients_archive: "/dashboard/patients/archive",
    patients_smsConsent: "/dashboard/patients/smsConsent",
    patients_patient_editPatient: "/dashboard/patients/patient/editPatient",
    patients_patient_billingTimer: "/dashboard/patients/patient/billingTimer",
    patients_patient_call: "/dashboard/patients/patient/call",
    patients_patient_askDocAssist: "/dashboard/patients/patient/askDocAssist",
    patients_patient_voiceTranslation:
        "/dashboard/patients/patient/voiceTranslation",
    patients_patient_hardAlert: "/dashboard/patients/patient/hardAlert",
    patients_patient_summaryAlert: "/dashboard/patients/patient/summaryAlert",
    patients_patient_overview: "/dashboard/patients/patient/overview",
    patients_patient_assessment: "/dashboard/patients/patient/assessment",
    patients_patient_assessment_createAssessment:
        "/dashboard/patients/patient/assessment/createAssessment",
    patients_patient_assessment_editTest:
        "/dashboard/patients/patient/assessment/editTest",
    patients_patient_assessment_viewTest:
        "/dashboard/patients/patient/assessment/viewTest",
    patients_patient_assessment_takeTest:
        "/dashboard/patients/patient/assessment/takeTest",
    patients_patient_assessment_deleteTest:
        "/dashboard/patients/patient/assessment/deleteTest",
    patients_patient_assessment_sdohGraph:
        "/dashboard/patients/patient/assessment/sdohGraph",
    patients_patient_assessment_phq9Graph:
        "/dashboard/patients/patient/assessment/phq9Graph",
    patients_patient_assessment_gad7Graph:
        "/dashboard/patients/patient/assessment/gad7Graph",
    patients_patient_assessment_pssGraph:
        "/dashboard/patients/patient/assessment/pssGraph",
    patients_patient_assessment_rseGraph:
        "/dashboard/patients/patient/assessment/rseGraph",
    patients_patient_assessment_alcoholGraph:
        "/dashboard/patients/patient/assessment/alcoholGraph",
    patients_patient_assessment_mdqGraph:
        "/dashboard/patients/patient/assessment/mdqGraph",
    patients_patient_assessment_outcomeGraph:
        "/dashboard/patients/patient/assessment/outcomeGraph",
    patients_patient_careplan: "/dashboard/patients/patient/careplan",
    patients_patient_careplan_createCarePlan:
        "/dashboard/patients/patient/careplan/createCarePlan",
    patients_patient_careplan_createActivities:
        "/dashboard/patients/patient/careplan/createActivities",
    patients_patient_careplan_bulkUpdate:
        "/dashboard/patients/patient/careplan/bulkUpdate",
    patients_patient_notes: "/dashboard/patients/patient/notes",
    patients_patient_notes_addNotes:
        "/dashboard/patients/patient/notes/addNotes",
    patients_patient_notes_downloadNotes:
        "/dashboard/patients/patient/notes/downloadNotes",
    patients_patient_notes_editNote:
        "/dashboard/patients/patient/notes/editNote",
    patients_patient_appointments: "/dashboard/patients/patient/appointments",
    patients_patient_appointments_createAppointment:
        "/dashboard/patients/patient/appointments/createAppointment",
    patients_patient_appointments_appointment_reschedule:
        "/dashboard/patients/patient/appointments/appointmnent/reschedule",
    patients_patient_appointments_appointment_cancel:
        "/dashboard/patients/patient/appointments/appointmnent/cancel",
    patients_patient_resources: "/dashboard/patients/patient/resources",
    patients_patient_activityLog: "/dashboard/patients/patient/activityLog",
    patients_patient_activityLog_downloadActivityLogReport:
        "/dashboard/patients/patient/activityLog/downloadActivityLogReport",
    patients_patient_callSummary: "/dashboard/patients/patient/callSummary",
    patients_patient_callSummary_teleHealth:
        "/dashboard/patients/patient/callSummary/teleHealth",
    patients_patient_callSummary_inPerson:
        "/dashboard/patients/patient/callSummary/inPerson",
    appointments: "/dashboard/appointments",
    appointments_createAppointment: "/dashboard/appointments/createAppointment",
    appointments_upcomingAppointment:
        "/dashboard/appointments/upcomingAppointment",
    appointments_completedAppointment:
        "/dashboard/appointments/completedAppointment",
    appointments_cancelledAppointment:
        "/dashboard/appointments/cancelledAppointment",
    callLogs: "/dashboard/callLogs",
    callLogs_all: "/dashboard/callLogs/all",
    callLogs_inbound: "/dashboard/callLogs/inbound",
    callLogs_outbound: "/dashboard/callLogs/outbound",
    callLogs_missed: "/dashboard/callLogs/missed",
    callLogs_marketing: "/dashboard/callLogs/marketing",
    reports: "/dashboard/reports",
    reports_consentReport: "/dashboard/reports/consentReport",
    reports_appointmentsReport: "/dashboard/reports/appointmentsReport",
    reports_bhnTimeSpentReport: "/dashboard/reports/bhnTimeSpentReport",
    reports_carePerformanceReport: "/dashboard/reports/carePerformanceReport",
    reports_revenueReport: "/dashboard/reports/revenueReport",
    reports_carePlanReport: "/dashboard/reports/carePlanReport",
    reports_moodAssessmentReport: "/dashboard/reports/moodAssessmentReport",
    resources: "/dashboard/resources",
    documents: "/dashboard/documents",
    documents_addDoc: "/dashboard/documents/addDoc",
    documents_status: "/dashboard/document/status",
    invoices: "/dashboard/invoices",
    invoices_viewInvoice: "/dashboard/invoices/viewInvoice",
    summary: "/dashboard/summary",
    summary_viewSummary: "/dashboard/summary/viewSummary",
    notifications: "/dashboard/notifications",
    messageCenter: "/dashboard/messageCenter",
    orgDropDown: "orgDropdown",
    clinicDropDown: "clinicDropdown",
    manage: "/dashboard/manage",
    organizations: "/dashboard/manage/organizations",
    organizations_addOrg: "/dashboard/manage/organizations/addOrg",
    organizations_organization_editOrg:
        "/dashboard/manage/organizations/organization/editOrg",
    organizations_organization_addClinic:
        "/dashboard/manage/organizations/organization/addClinic",
    organizations_organization_clinics:
        "/dashboard/manage/organizations/organization/clinics",
    organizations_organization_users:
        "/dashboard/manage/organizations/organization/users",
    organizations_organization_addUser:
        "/dashboard/manage/organizations/organization/addUser",
    organizations_organization_clinic_editClinic:
        "/dashboard/manage/organizations/organization/clinic/editClinic",
    organizations_organization_clinic_addUser:
        "/dashboard/manage/organizations/organization/clinic/addUser",
    // organizations: "/dashboard/organizations",
    // organizations_addOrg: "/dashboard/organizations/addOrg",
    // organizations_organization_editOrg:
    //   "/dashboard/organizations/organization/editOrg",
    // organizations_organization_addClinic:
    //   "/dashboard/organizations/organization/addClinic",
    // organizations_organization_clinics:
    //   "/dashboard/organizations/organization/clinics",
    // organizations_organization_users:
    //   "/dashboard/organizations/organization/users",
    // organizations_organization_addUser:
    //   "/dashboard/organizations/organization/addUser",
    organizations_organization_editUser:
        "/dashboard/manage/organizations/organization/editUser",
    organizations_organization_editUser_deleteUser:
        "/dashboard/manage/organizations/organization/editUser/deleteUser",
    // organizations_organization_clinic_editClinic:
    //   "/dashboard/organizations/organization/clinic/editClinic",
    // organizations_organization_clinic_addUser:
    //   "/dashboard/organizations/organization/clinic/addUser",
    organizations_organization_clinic_editUser:
        "/dashboard/manage/organizations/organization/clinic/editUser",
    organizations_organization_clinic_editUser_deleteUser:
        "/dashboard/manage/organizations/organization/clinic/editUser/deleteUser",
    consent_overview: "/consent/overview",
    consent_notes: "/consent/notes",
    carecall_overview: "/carecall/overview",
    carecall_careplan: "/carecall/careplan",
    carecall_notes: "/carecall/notes",
    patients_patient_appointments_makePayment:
        "/dashboard/patients/patient/appointments/makePayment",
    patients_patient_messageCenter: "/dashboard/patients/patient/messageCenter",
    messageCenter_bulkSms: "/dashboard/messageCenter/bulkSms",
    user_consultationFees:
        "/dashboard/userProfile/settingsPreferences/consultationFees",
    postCall_addNotes: "/dashboard/postCall/addNotes",
    postCall_edit: "/dashboard/postCall/editNotes",
    summary_pending: "/dashboard/summary/pending",
    summary_viewPatient: "/dashboard/summary/viewPatient",
    summary_patientSummary_approve: "/dashboard/summary/patientSummary/approve",
    summary_patientSummary_reject: "/dashboard/summary/patientSummary/reject",
    summary_patientSummary_share_via_email:
        "/dashboard/summary/patientSummary/shareViaEmail",
    summary_patientSummary_download:
        "/dashboard/summary/patientSummary/download",
    playground: "/dashboard/manage/aiplayground",
    patients_patient_regenerateSummary:
        "/dashboard/patients/patient/regenerateSummary",
    summary_patientSummary_editProfile:
        "/dashboard/summary/patientSummary/editProfile",
    summary_patientSummary_editAssessments:
        "/dashboard/summary/patientSummary/editAssessments",
    summary_patientSummary_editCarePlan:
        "/dashboard/summary/patientSummary/editCarePlan",
    summary_patientSummary_editNotes:
        "/dashboard/summary/patientSummary/editNotes",
}

export const checkAccess = (accessFor, resourceList = null) => {
    let resources = resourceList || store.getState().login.resources
    let returnBool = false
    if (resources.length > 0) {
        returnBool = resources.includes(accessFor)
    } else {
        returnBool = false
    }
    return returnBool
}
